export default "__VITE_ASSET__CYw$dJI7__"